import type {
  WithdrawCommissionData,
  WithdrawGetCommissionProps,
} from '@/shared/types';
import { applyAmountPrecision, formatReceivedAmount } from '@/shared/lib';
import { NUMERIC_CONFIG } from '@/shared/config';
import Big from 'big.js';

export function getCalculatedCommission({
  amount,
  includeFee = false,
  fee = 0,
  assetCode,
  precision = NUMERIC_CONFIG.precision.default,
}: WithdrawGetCommissionProps): WithdrawCommissionData {
  const totalWithdrawAmount = amount;
  const toBeReceived = totalWithdrawAmount
    ? new Big(totalWithdrawAmount).minus(fee).toNumber()
    : 0;
  const code = assetCode || '';

  const finalPrecision = totalWithdrawAmount > 0 ? precision : 1;
  const finalTotalAmount = applyAmountPrecision(
    totalWithdrawAmount,
    finalPrecision,
    'credit'
  );
  const finalToBeReceived = applyAmountPrecision(
    toBeReceived,
    finalPrecision,
    'credit'
  );

  return {
    amount,
    includeFee,
    fee,
    feeStr: `${formatReceivedAmount(fee)} ${code}`,
    totalWithdrawAmount: finalTotalAmount,
    totalWithdrawAmountStr: `${formatReceivedAmount(finalTotalAmount)} ${code}`,
    toBeReceived: finalToBeReceived,
    toBeReceivedStr: `${formatReceivedAmount(finalToBeReceived)} ${code}`,
  };
}
